/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_BookingInputs */

const en_coaching_booking = /** @type {(inputs: Coaching_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing…`)
};

const id_coaching_booking = /** @type {(inputs: Coaching_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyiapkan…`)
};

/**
* | output |
* | --- |
* | "Preparing…" |
*
* @param {Coaching_BookingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_booking = /** @type {((inputs?: Coaching_BookingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_BookingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_booking(inputs)
	return en_coaching_booking(inputs)
});